import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '../_shared/loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

  constructor(private loaderService: LoaderService) { }
  private currentStatus: ReplaySubject<any> = new ReplaySubject<any>(1);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.showLoader();

    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if(event instanceof HttpResponse) {
        this.onEnd();
      }
    },
      (err: any) => {
        this.onEnd();
      }));

  }

  private onEnd(): void {
    this.hideLoader();
  }

  private showLoader(): void {
    this.setCurrent(true);
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.setCurrent(false);
    this.loaderService.hide();
  }

  public setCurrent(status: boolean) {
    this.currentStatus.next(status);
  }
  getCurrentStatus() {
    return this.currentStatus;
  }

}
